import React, { useEffect, useState, useContext, useMemo  } from "react";
import { flightAvailability } from "../../Services/API";
import { useLocation } from "react-router-dom";
import { flightPricing } from "../../Services/API";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../../Routes/AuthProvider";
import Header from "../../Components/Header";
import ModifySearch from "./ModifySearch";

import ResultHtml from "./ResultHtml";
import DomRoundTrip from "./DomRoundTrip";
import IntRoundTrip from "./IntRoundTrip";
import FilterSidebar from "./FilterSidebar";
import { useNavigate } from "react-router-dom";


const Result = () => {
  const { agencyId, userName } = useContext(AuthContext);
  const [flights, setFlights] = useState([]);
  const [onwardList, setOnwardList] = useState([]);
  const [returnList, setReturnList] = useState([]);
  const [flightRequst, setFlightRequst] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [allCompleted, setAllCompleted] = useState(false);
         
  const [onwardFlights, setOnwardFlights] = useState([]); // one-way
  const [returnFlights, setReturnFlights] = useState([]); // round trip

  const [flightRequest, setFlightRequest] = useState(null);

  const searchData =
  location.state ||
  JSON.parse(sessionStorage.getItem("searchData")) ||
  Object.fromEntries(new URLSearchParams(location.search));
  
  const data = searchData.searchParams || searchData;
  const [guidNo, setGuidNo] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const flightlist =
    location.state ||
    JSON.parse(sessionStorage.getItem("searchData") || "{}");

  const {
    onwardDate = "",
    returnDate = "",
    departureQuery = "",
    arrivalQuery = ""
  } = flightlist;




  const isRoundTrip = !!returnDate;
  const indianAirports = [
    "DEL", "BOM", "MAA", "BLR", "HYD", "CCU", "GOI", "PNQ", "AMD", "COK", "TRV",
    "IXC", "LKO", "GAU", "PAT", "RPR", "JAI", "IXB", "VNS", "SXR", "UDR", "BHO", "NAG"
  ];

  const originCode = data.departureQuery?.split("(")[1]?.split(")")[0];
  const destCode = data.arrivalQuery?.split("(")[1]?.split(")")[0];

  const isDomestic =
    indianAirports.includes(originCode) &&
    indianAirports.includes(destCode);



  // const isDomestic =
  //   departureQuery?.includes("India") && arrivalQuery?.includes("India");

  const [filters, setFilters] = useState({
    onwardDate: data.onwardDate || "",
    returnDate: data.returnDate || ""
  });


  const handleFilterChange = (updatedFilter) => {
    setFilters((prev) => ({ ...prev, ...updatedFilter }));
  };


  const filteredFlights = flights.filter((f) => {

    const segment = f.segments?.[0];
    if (!segment) return false;

    const departDateTime = segment.departDateTime;
    const apiDate = departDateTime?.split("T")[0]; // FIXED (no timezone shift)

    //  DATE FILTER
    if (filters.onwardDate && apiDate !== filters.onwardDate) return false;

    // AIRLINES FILTER
    if (filters.airlines?.length > 0) {
      const airlineName =
        segment.airLineName ||
        segment.carrierName ||
        segment.airlineName ||
        "";

      if (!filters.airlines.includes(airlineName)) return false;
    }

    // STOP FILTER
    if (filters.stops?.length > 0) {
      const stopCount = String(f.stops ?? f.totalStops ?? 0);
      if (!filters.stops.includes(stopCount)) return false;
    }

    //  FARE TYPE FILTER
    if (filters.fareType?.length > 0) {
      const fareType = f.fares?.[0]?.isRefundable
        ? "Refundable"
        : "Non-Refundable";
      if (!filters.fareType.includes(fareType)) return false;
    }

    //  DEPARTURE TIME FILTER
    if (filters.departureTimes?.length > 0) {
      const hour = new Date(departDateTime).getHours();

      const category =
        hour >= 5 && hour <= 11
          ? "morning"
          : hour >= 12 && hour <= 17
            ? "afternoon"
            : hour >= 18 && hour <= 20
              ? "evening"
              : hour >= 21 && hour <= 23
                ? "night"
                : "lateNight";

      if (!filters.departureTimes.includes(category)) return false;
    }

    return true; // KEEP the flight
  });


  useEffect(() => {
    setGuidNo(uuidv4());
  }, []);

  const [selectedFare, setSelectedFare] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);


  const segments = [
    {
      origin: data.departureQuery?.split("(")[1]?.split(")")[0] || "",
      destination: data.arrivalQuery?.split("(")[1]?.split(")")[0] || "",
      departDate: data.onwardDate ? formatDateForAPI(data.onwardDate) : "",
      preferredClass: data.selClass || "ECONOMY",
    }
  ];

  if (isRoundTrip) {
    segments.push({
      origin: data.arrivalQuery?.split("(")[1]?.split(")")[0] || "",
      destination: data.departureQuery?.split("(")[1]?.split(")")[0] || "",
      departDate: data.returnDate ? formatDateForAPI(data.returnDate) : "",
      preferredClass: data.selClass || "ECONOMY",
    });
  }

  const requestBody = {
    trip: isDomestic ? 1 : 2,
    tripType: isRoundTrip ? 2 : 1,

    origin: segments[0].origin,
    destination: segments[0].destination,

    adult: Number(data.adult || 1),
    child: Number(data.child || 0),
    infant: Number(data.infant || 0),

    departDate: segments[0].departDate,
    returnDate: isRoundTrip ? segments[1].departDate : "",

    clientCode: "BerryJourneys",
    rtf: true,
    nonStop: !!data.nonStop,
    currency: "INR",
    planType: "NRML",
    preferredClass: data.selClass || "ECONOMY",
    preferredCarrier: data.airlinePreference || "",
    key: guidNo,
    sessionID: "",
    userID: userName,

    segments: segments,

    preferredDepartureTime: 0,
    preferredArrivalTime: 0,
    fareType: data.typeFare || "",
    agencyId: agencyId,
    source: "",
    originCountry: "IN",
    destinationCountry: "IN",
  };

  //  Helper: Convert YYYY-MM-DD ? DD/MM/YYYY for API
  function formatDateForAPI(dateStr) {
    if (!dateStr) return "";
    const [y, m, d] = dateStr.split("-");
    return `${d}/${m}/${y}`;
  }

  //  Helper: Format time for display
  const formatTime = (dt) => {
    if (!dt) return "";
    try {
      const d = new Date(dt);
      return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } catch {
      return dt;
    }
  };

  const hasFetched = React.useRef(false);

 useEffect(() => {
    if (!guidNo) return;
    if (hasFetched.current) return;
    hasFetched.current = true;

    setLoading(true);
    setError(null);
    setAllCompleted(false);
    setFlights([]);
    setOnwardFlights([]);
    setReturnFlights([]);
    setFlightRequest(requestBody);

    flightAvailability(requestBody, (data) => {
      if (data.allCompleted) {
        setLoading(false);
        setAllCompleted(true);
        return;
      }

      if (data.status === "done") {
        setFlights((prev) => [...prev, ...(data.onward || [])]);
        setOnwardFlights((prev) => [...prev, ...(data.onward || [])]);
        setReturnFlights((prev) => [...prev, ...(data.return || [])]);
      }
    });
  }, [guidNo]);

  const getFilteredFlights = (list) => {
    return list.filter((f) => {
      const segment = f.segments?.[0];
      if (!segment) return false;

      if (filters.onwardDate &&
        segment.departDateTime?.split("T")[0] !== filters.onwardDate)
        return false;

      if (filters.airlines?.length &&
        !filters.airlines.includes(segment.airLineName))
        return false;

      const stops = String(f.stops ?? f.totalStops ?? 0);
      if (filters.stops?.length && !filters.stops.includes(stops))
        return false;

      if (filters.fareType?.length) {
        const fareType = f.fares?.[0]?.isRefundable
          ? "Refundable"
          : "Non-Refundable";
        if (!filters.fareType.includes(fareType)) return false;
      }

      if (filters.departureTimes?.length) {
        const hour = new Date(segment.departDateTime).getHours();
        const category =
          hour >= 5 && hour <= 11
            ? "morning"
            : hour >= 12 && hour <= 17
              ? "afternoon"
              : hour >= 18 && hour <= 20
                ? "evening"
                : hour >= 21 && hour <= 23
                  ? "night"
                  : "lateNight";

        if (!filters.departureTimes.includes(category)) return false;
      }

      return true;
    });
  };

  const filteredOnward = useMemo(
  () => getFilteredFlights(onwardFlights),
  [onwardFlights, filters]
);

const filteredReturn = useMemo(
  () => getFilteredFlights(returnFlights),
  [returnFlights, filters]
);


  const filteredAll = getFilteredFlights(flights);
  


  //  Total passenger count
  const totalPax =
    Number(data.adult || 0) +
    Number(data.child || 0) +
    Number(data.infant || 0);

  // Pricing start


  //  all hooks declared here
  const handleBookNow = async (flight, index) => {
    try {
      setLoadingFlightIndex(index);

      // Allow React time to update UI
      await new Promise((r) => setTimeout(r, 100));

      // const traceId = flight.TraceId || searchData.TraceId;
      // const firstLeg = flight.FlightDetails?.[0] || {};

      const Journey = "Onward";
      const ClassOfService = "E";

      console.log("userName", userName);
      console.log("guidNo", guidNo);
      console.log("agencyId", agencyId);
      console.log("flight", flight);
      console.log("Journey", Journey);
      console.log("ClassOfService", ClassOfService);
      console.log("flightRequst", flightRequst);

      const response = await flightPricing(
        "BerryJourneys",
        userName,
        guidNo,
        agencyId,
        flight,
        Journey,
        ClassOfService,
        flightRequst,
      );

      if (response?.status === "Success" && !response.isPriceChange) {
        navigate(`/Flight/booking?ReferenceNo=${response.referenceNo}&ClientCode=BerryJourneys&Key=${response.key}`);
        window.location.reload();
        return; // No reload
      }

      if (response?.status === "Success" && response.isPriceChange) {
        alert("The fares of selected flight has increased.");
      } else {
        alert(response?.error?.description || "Fare not found. Please try again.");
      }

    } catch (error) {
      console.error("Error fetching flight pricing:", error);
      alert("Unable to fetch flight price right now. Please try again later.");
    } finally {
      setLoadingFlightIndex(null);
    }
  };



  return (
    <>
      <Header />
      <section class="wrapers results">
        <div class="row">
          <div class="col-md-3 col-lg-3">

            <FilterSidebar
              flights={flights}
              filters={filters}
              onFilterChange={handleFilterChange}
            />

          </div>

          <div class="col-md-9 col-lg-9">
            <div class="box_shadow_wbg">
              {!isRoundTrip && onwardDate && (
                <ResultHtml
                  data={data}
                  totalPax={totalPax}
                  requestBody={requestBody}
                  flights={filteredFlights}
                  loading={loading}
                  error={error}
                  handleBookNow={handleBookNow}
                />
              )}



              {isRoundTrip && isDomestic && (
                <DomRoundTrip
                  onwardFlights={onwardFlights}
                  returnFlights={returnFlights}
                  filteredOnwardFlights={filteredOnward}
                  filteredReturnFlights={filteredReturn}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  loading={loading}
                  data={{
                    ...data,
                    departureAirportCode: originCode,
                    arrivalAirportCode: destCode
                  }}
                  error={error}
                  handleBookNow={handleBookNow}
                  requestBody={{}} // cleaned
                />

              )}




              {isRoundTrip && !isDomestic && (
                <IntRoundTrip
                  totalPax={totalPax}
                  requestBody={requestBody}
                  flights={filteredFlights}
                  loading={loading}
                  data={{
                    ...data,
                    departureAirportCode: originCode,
                    arrivalAirportCode: destCode,
                  }}
                  handleBookNow={handleBookNow}
                />
              )}

              {/* <MultiCityresult /> */}
              {/* Domestic  */}
              {/* <MultiCityDomResult /> */}
              {/* International  */}
              {/* <MultiCityIntResult /> */}

            </div>
          </div>

        </div>
      </section>



      <div class="modal fade" id="MapView">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Map View</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">Modal body..</div>
          </div>
        </div>
      </div>


      {/* Modify Result Modal */}
      <div className="modal fade" id="ModifyResult">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Modify Result</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body-update">
              <ModifySearch />
            </div>
          </div>
        </div>
      </div>
      {/* popup start */}

      <div
        className="offcanvas offcanvas-end"
        id="ViewMoreFare"
        tabIndex="-1"
        aria-labelledby="ViewMoreFareLabel"
      >
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight.segments?.[0]?.airLineName || "airline"}
                    src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>
                <div className="flight_time">
                  <span>
                    <strong>
                      {selectedFlight.origin} ({selectedFlight.segments?.[0]?.departAirportCode}) ?{" "}
                      {selectedFlight.destination} ({selectedFlight.segments?.[0]?.arrivalAirportCode})
                    </strong>
                  </span>
                  <span>
                    <strong>{selectedFlight.segments?.[0]?.airLineName}</strong>
                  </span>
                  <span>
                    <strong>
                      {new Date(
                        selectedFlight.segments?.[0]?.departDateTime
                      ).toDateString()}
                    </strong>
                  </span>
                  <span>
                    Departure at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</strong>
                  </span>
                  <span>
                    Arrival at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</strong>
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares?.length > 0 ? (
                  selectedFlight.fares.map((fare, index) => (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare.fareType || "Standard Fare"}</h5>
                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>

                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>



                      </div>

                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setSelectedFare(fare);
                            setSelectedFareIndex(index); // <-- IMPORTANT
                          }}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No fare options available</p>
                )}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>

        {selectedFare && (
          <div className="total_amount border-top p-3">
            <p className="Grand">Grand Total</p>
            <h1>
              <i className="fa fa-inr"></i>{" "}
              {selectedFare?.totalFare?.toLocaleString("en-IN")}
            </h1>

            <button
              className="btn btn-primary"
              onClick={() => handleBookNow(selectedFlight, selectedFareIndex)}
              disabled={loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex}
            >
              {loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex
                ? "Checking Price..."
                : "Book Now"}


            </button>

          </div>
        )}
      </div>


      <div className="offcanvas offcanvas-end" tabIndex="-1" id="FlightDetails" aria-labelledby="FlightDetailsLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>

              <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#kt_tab_pane_4">Flight Information</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_5">Fare Details &amp; Rules</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_6">Baggage Information</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_7">Cancellation &amp; Change Rule</a></li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="kt_tab_pane_4" role="tabpanel">
                  <h3 class="destnation"> {selectedFlight.origin} ({selectedFlight.segments?.[0]?.departAirportCode}) <i class="fa fa-arrow-right"></i>
                    {selectedFlight.destination} ({selectedFlight.segments?.[0]?.arrivalAirportCode})</h3>
                  <ul class="rlst_flight_detls">
                    {/* <li>{selectedFlight.tripType === 1 ? "One Way" : "Round Trip"}</li> */}
                    <li>{selectedFlight.selClass || "Economy"}</li>
                    <li>{selectedFlight.adult + selectedFlight.child + selectedFlight.infant} Traveller(s)</li>
                    <li>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</li>
                  </ul>
                  <div class="d-flex flgt_dlts">
                    <div class="img_img_flight">
                      <img className="flight_i" src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                    </div>
                    <div class="text_img_t">
                      <h5>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</h5>
                      <p>{selectedFlight.origin} - {selectedFlight.destination} | {selectedFlight.segments?.[0]?.duration || "Duration N/A"} </p>
                    </div>
                  </div>
                  <div class="d-flex-v">
                    <div class="d-flex-v-f"><h4>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</h4></div>
                    <div class="d-flex-v-m"><span class="zero"></span></div>
                    <div class="d-flex-v-l">
                      <h4>{selectedFlight.origin}</h4>
                      <p>  {selectedFlight.segments?.[0]?.departAirportName}
                        {selectedFlight.segments?.[0]?.departTerminal
                          ? `, Terminal ${selectedFlight.segments?.[0]?.departTerminal}`
                          : ""}</p>
                    </div>
                  </div>
                  <div class="d-flex-v time_to_frm">
                    <div class="d-flex-v-f m-autto"><h6>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()} </h6></div>
                    <div class="d-flex-v-m fhty_rg"><i class="fa fa-plane flights"></i></div>
                    <div class="d-flex-v-l m-autto">
                      <div class="d-flex">
                        <div class="img_flt"><img className="flight_i" src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} /></div>
                        <div className="flt_name">
                          {selectedFlight.segments?.[0]?.airLineName} -
                          {selectedFlight.segments?.[0]?.airLineCode}-
                          {selectedFlight.segments?.[0]?.flightNumber}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex-v">
                    <div class="d-flex-v-f"><h4>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</h4></div>
                    <div class="d-flex-v-m"><span class="zero"></span></div>
                    <div class="d-flex-v-l">
                      <h4>{selectedFlight.destination}</h4>
                      <p>  {selectedFlight.segments?.[0]?.arrivalAirportName}
                        {selectedFlight.segments?.[0]?.arrivalTerminal
                          ? `, Terminal ${selectedFlight.segments?.[0]?.arrivalTerminal}`
                          : ""}</p>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to cancel<br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Cancel Before 72 hours of departure time.</td>
                              <td>3,999</td>

                            </tr>
                            <tr>
                              <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>3,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to reschedule <br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Reschedule before 72 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>
                            <tr>
                              <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <h4>Terms &amp; Conditions</h4>
                        <ul>
                          <li>Total Rescheduling Charges Airlines Rescheduling fees Fare Difference if applicable.</li>
                          <li>The airline cancel reschedule fees is indicative and can be changed without any prior notice by the airlines..</li>
                          <li>Berry Journeys does not guarantee the accuracy of cancel reschedule fees.</li>
                          <li>Partial cancellation is not allowed on the flight tickets which are book under special round trip discounted fares.</li>
                          <li>Airlines doesnt allow any additional baggage allowance for any infant added in the booking</li>
                          <li>In certain situations of restricted cases, no amendments and cancellation is allowed</li>
                          <li>Airlines cancel reschedule should be reconfirmed before requesting for a cancellation or amendment</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`https://www.d2wtravel.com/Content/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_7" role="tabpanel">
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to cancel <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Cancel Before 72 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>4,999</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to reschedule <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Reschedule before 72 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="total_amount">
                <p class="Grand">Grand Total</p>
                <h1>
                  <i className="fa fa-inr"></i>{" "}
                  {Number(selectedFlight.fares?.[0]?.totalFare || 0).toLocaleString()}
                </h1>
                {/* <button class="btn btn-primary">Book Now</button> */}
                <button
                  className="btn btn-primary"
                  onClick={() => handleBookNow(selectedFlight, selectedFareIndex)}
                  disabled={loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex}
                >
                  {loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex
                    ? "Checking Price..."
                    : "Book Now"}

                </button>

              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>



    </>
  )
};

export default Result;